import React, { createContext } from "react";
import {Dbx} from './dbx';

const DbxContext = createContext();

const DbxContextProvider = ({children}) => {
    return (
        <DbxContext.Provider value={Dbx}>
            {children}
        </DbxContext.Provider>
    );
}

export {DbxContext, DbxContextProvider};